import React from 'react';

class Settings extends React.Component {
  render() {
    return (
      <div>
        <h1 data-testid="settings-title">Settings page</h1>
        <img src="https://c.tenor.com/0T6CQm60M8sAAAAC/fatcatzcouple-yellow-cat.gif" alt="Still working" />
      </div>
    );
  }
}

export default Settings;
